import Masked from './Masked';

interface NameParts {
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

interface CustomerNameProps {
  /**
   * The person object to format, e.g. `complaint.userDatum` (consumer) or
   * `complaint.representativeDatum` (representative). Mutually exclusive
   * with `name` — pass whichever the call site already has.
   */
  user?: NameParts | null;
  /**
   * A pre-built name string, for call sites that already compose
   * `title/firstName/lastName` themselves. Mutually exclusive with `user`.
   */
  name?: string | null;
  className?: string;
}

/**
 * Person-name masker used for BOTH the consumer and the representative
 * (Medallia DXA PII masking, CD-8245).
 *
 * Reproduces the same `${title} ${firstName} ${lastName}` formatting as
 * res-components `UserName`/`userNameString` (falsy parts filtered out,
 * remaining parts joined with a single space) so call sites that migrate to
 * this component render identical output, plus the mask attribute. Accepts
 * either the raw person object (`user`) or an already-built string (`name`)
 * to match whatever the current call site has to hand.
 */
export function CustomerName({ user, name, className }: CustomerNameProps) {
  const value = name ?? formatName(user);

  return <Masked className={className}>{value}</Masked>;
}

function formatName(user?: NameParts | null): string {
  if (!user) {
    return '';
  }

  return [user.title, user.firstName, user.lastName].filter(Boolean).join(' ');
}

export default CustomerName;
